
import { Container, Row, Col, Nav } from 'react-bootstrap'
import { Link, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Version from '../../version'
import { useAuth } from '../auth/useAuth'
import { useEffect, useState } from 'react'

export default function Sidebar({ rol }) {
	const { t } = useTranslation()
	const { pathname } = useLocation()
	const { clientauth, logoutClient } = useAuth()
	const [rolTranslated, setRolTranslated] = useState('')

	useEffect(() => {
		if (rol === 'admin') {
			setRolTranslated('admin')
		} else if (rol === 'rrhh') {
			setRolTranslated('admin')
		} else if (rol === 'employee') {
			setRolTranslated('empleado')
		}
	}, [rol])

	return (
		<Container fluid className="sidebar d-none d-sm-block" id="sidebar">
			<div className='d-flex flex-column h-100 justify-content-between'>
				<div>
					<Row>
						<Col className='d-flex text-white'>
							<div>
								<img src="/images/logotipo-blanco.svg" alt="logotipo" width={80}/>
							</div>
							<div className='mt-1'>
								<div className='fs-6 fw-light text-white mb-0'>SILBON</div>
								<small className='fw-light'>{t('signin.claim')}</small>
							</div>
						</Col>
					</Row>
					<hr className="separador opacity-50" />
					<Nav as="ul" className="flex-column p-0 main-nav">
						<Nav.Item as="li" className={pathname.includes(`${t('url.'+rolTranslated)}/${t('url.dashboard')}` ) ? 'active' : ''}>
							<Link className="nav-link-pill" to={`/${t('url.'+rolTranslated)}/${t('url.dashboard')}`}>
								<img src="/images/dashboard.svg" alt="dashboard" width={20} className='me-2'/>{t('menu.dashboard')}
							</Link>
						</Nav.Item>

						{(rolTranslated === 'admin' || rolTranslated === 'rrhh') && (
							<>
								<Nav.Item as="li" className={pathname.includes(`${t('url.'+rolTranslated)}/${t('url.users')}` ) ? 'active' : ''}>
									<Link className="nav-link-pill" to={`/${t('url.'+rolTranslated)}/${t('url.users')}`}>
										<img src="/images/profile.svg" alt="users" width={20} className='me-2'/>{t('menu.users')}
									</Link>
								</Nav.Item>
								<Nav.Item as="li" className={pathname.includes(`${t('url.'+rolTranslated)}/${t('url.documentsManagement')}` ) ? 'active' : ''}>
									<Link className="nav-link-pill" to={`/${t('url.'+rolTranslated)}/${t('url.documentsManagement')}`}>
										<img src="/images/documents.svg" alt="documents" width={20} className='me-2'/>{t('menu.documents')}
									</Link>
								</Nav.Item>
							</>
						)}

						{(rolTranslated === 'employee') && (
							<>
							</>
						)}
						<Nav.Item as="li" className={pathname.includes(`${t('url.'+rolTranslated)}/${t('url.odoo')}` ) ? 'active' : ''}>
							<Link className="nav-link-pill" to={`/${t('url.'+rolTranslated)}/${t('url.odoo')}`}>
								<img src="/images/ticket.svg" alt="odoo" width={20} className='me-2'/>{t('menu.odoo')}
							</Link>
						</Nav.Item>
						<Nav.Item as="li" className={pathname.includes(`${t('url.'+rolTranslated)}/${t('url.chatbot')}` ) ? 'active' : ''}>
							<Link className="nav-link-pill" to={`/${t('url.'+rolTranslated)}/${t('url.chatbot')}`}>
								<img src="/images/chatbot-menu.svg" alt="chatbot" width={20} className='me-2'/>{t('menu.chatbot')}
							</Link>
						</Nav.Item>
					</Nav>
				</div>
				<div className='footer-sidebar text-white'>
					<hr className="separador opacity-50" />
					<div className="p-3">
						{clientauth?.name}<br/>
						<span className='opacity-50'>{clientauth?.email}</span>
					</div>
					<Nav as="ul" className="flex-column p-0 main-nav">
						<>
							<Nav.Item as="li" onClick={logoutClient}>
								<Link className="nav-link-pill" to={"/"}>
									<img src="/images/myprofile.svg" alt="logout" width={20} className='me-2'/>{t('menu.myprofile')}
								</Link>
							</Nav.Item>
							<Nav.Item as="li" onClick={logoutClient}>
								<Link className="nav-link-pill" to={"/"}>
									<img src="/images/logout.svg" alt="logout" width={20} className='me-2'/>{t('global.logout')}
								</Link>
							</Nav.Item>
						</>
					</Nav>
					<div className='text-center opacity-50 text-white'>
						<Version />
					</div>
				</div>
			</div>
		</Container>
	)
}
